import { mainAPI } from "../../api";

import { ApiErrorResponse } from "../../types/api/error";
import {
  CountriesListRequest,
  CountryListResponse,
} from "../../types/api/countries";

const path = `/geo/${process.env.REACT_APP_API_VERSION}/countries`;

export function fetchCountriesList(params: CountriesListRequest) {
  return mainAPI.get<CountryListResponse[]>(`${path}`, { params }).then(
    (res) => {
      const countHeader = res.headers["count"];
      return Promise.resolve({
        list: res.data,
        totalCount: countHeader,
      });
    },
    (error) => {
      const apiError: ApiErrorResponse = error.response?.data;
      return Promise.reject(new Error(apiError?.detail || "Произошла ошибка"));
    }
  );
}
